<template>
  <exception
    code="404"
    meaasge="哎呀...找不到页面了！"
    :form="from"/>
</template>

<script>
import Exception from '@core/pages/exception/Exception'

export default {
  components: {Exception},
  data () {
    return {
      from: null,
    }
  },
  beforeRouteEnter (to, from, next) { /* 在导航转入新的路由前获取数据, 不能获取this */
    next(vm => {
      vm.from = from
    })
  },
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// core/pages/exception/NotFound.vue